import { useMutation, useQueryClient } from '@tanstack/react-query'
import { InviteService } from '../../lib/api'
import {
	AcceptInviteRequest,
	InviteAcceptResponseData,
} from '../../lib/api/types/invite.interfaces'

export const useAcceptInvite = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation<
		InviteAcceptResponseData,
		unknown,
		AcceptInviteRequest
	>({
		mutationKey: ['invite', 'accept'],
		mutationFn: InviteService.acceptInvite,
		onSuccess: (_response, { mode }) => {
			if (mode !== 'user') return

			queryClient.invalidateQueries({ queryKey: ['auth', 'me'] })
			queryClient.invalidateQueries({ queryKey: ['user'] })
		},
	})

	type MutationAsyncParameters = Parameters<typeof mutation.mutateAsync>
	const mutateAsync = async (...params: MutationAsyncParameters) => {
		try {
			await mutation.mutateAsync(...params)
		} catch (error) {
			console.error(error)
		}
	}

	return { ...mutation, mutateAsync }
}
